import { render, staticRenderFns } from "./authorDescPanel.vue?vue&type=template&id=606f38ba&scoped=true&"
import script from "./authorDescPanel.vue?vue&type=script&lang=js&"
export * from "./authorDescPanel.vue?vue&type=script&lang=js&"
import style0 from "./authorDescPanel.vue?vue&type=style&index=0&id=606f38ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606f38ba",
  null
  
)

export default component.exports